export const getSecondsFromMs = (number) => Math.round(number/100) / 10;
